<template>
  <div class="container" v-show="isShow">
    <a class="popup-close-button" @click="showEchartsAreas">x</a>
    
    <div class="containerBody">   
        <h3 style="color: white;">全国设备分布图</h3>
        <div class="content"  ref="areaChart" ></div>
    </div>
  </div>
</template>

<script>
import {toRaw} from 'vue'
import * as echarts from 'echarts'
// import {areasSiChuan} from '../../public/js/areasSiChuan.js'
import {mapDatas} from '../../public/js/mapDatas.js'
import axios from 'axios'
export default {
    name:'EchartsAreas',
    props:['getProvinceName'],
    data(){
        return {
            isShow:false ,
            areaChart:null,
            option:{},
            valueData:[
                { name: '天津', value: 1, itemStyle: {areaColor: '#faa'} },
                { name: '江西', value: 1, itemStyle: {areaColor: '#faa'} },
                { name: '福建', value: 1, itemStyle: {areaColor: '#faa'} },
                { name: '四川', value: 31, itemStyle: {areaColor: '#faa'} }],
            splitList:[],
            splitSeries:[]
        }
    },
    methods: {
        showEchartsAreas(){           
            this.isShow = !this.isShow ;
        },
        getHostListDatas(){
            axios.get('http://47.111.99.118:8089/system/HostList').then(
                response=>{
                    console.log('EchartsAreas 组件,请求数据=',response.data);
                    let datas = response.data.data;
                    let provins = [];
                    let jxPors = {};    // 江西省的信息
                    let tjPors = {};    // 天津的信息
                    let fjPors = {};    // 福建省的信息
                    let scPors = {};    // 四川省的信息
                    jxPors.value = 0;
                    tjPors.value = 0;
                    fjPors.value = 0;
                    scPors.value = 0;
                    datas.forEach(el=>{   
                        if(el.province == '江西省'){
                            jxPors.name = el.province ;
                            jxPors.value += 1 ;
                            jxPors.coord = [el.lon,el.lat,jxPors.value];
                        }else if(el.province == '四川省'){
                            scPors.name = el.province ;
                            scPors.value += 1 ;
                            scPors.coord = [el.lon,el.lat,scPors.value];
                        }else if(el.province == '福建省'){
                            fjPors.name = el.province ;
                            fjPors.value += 1 ;
                            fjPors.coord = [el.lon,el.lat,fjPors.value];
                        }else if(el.province == '天津'){
                            tjPors.name = el.province + '市' ;
                            tjPors.value += 1 ;
                            tjPors.coord = [el.lon,el.lat,tjPors.value];
                        }else{
                            console.log('需要添加该省份信息：',el.province);
                        }    
                    })
                    provins.push(jxPors);
                    provins.push(tjPors);
                    provins.push(fjPors);
                    provins.push(scPors);
                    console.log('EchartsAreas 组件,provins.length = ',provins.length,);
                    console.log('EchartsAreas 组件,provins = ',provins);
                    this.valueData = provins ;
                    this.setEchartsRegions();
                },
                error=>{
                    console.log('EchartsAreas 组件,请求数据失败',response.data);
                }
            )
        },
        setEchartsRegions(){
            let len = this.valueData.length ;
            let reg = [];
            let areaColors = ['red','orange','green','blue'];
            for(let i=0 ; i<len ; i++){
                reg.push(
                    {
                        name: this.valueData[i].name, //区块名称
                        itemStyle: {
                            normal: {
                                opacity:1,
                                areaColor: areaColors[(i%4)], // 区域颜色
                            }
                        }
                    },
                )
            }
            // console.log('EchartsAreas 组件,this.splitList = ',this.splitList);
            this.splitList = reg ;  
            this.setEchartsDatas();
            
        },
        setEchartsDatas(){
            let len = this.valueData.length ;
            let series = [];
            for(let i=0 ; i<len ; i++){
                let data = this.valueData[i];
                series.push(
                    {
                        type:'scatter',
                        symbol:'roundRect',
                        data:[
                            {
                                name:data.name,
                                value:data.coord
                            }
                        ],
                        coordinateSystem: "geo",
                        symbolSize:[20,70],
                        symbolOffset:[0, '-20%'],
                        label:{
                            show:true,
                            position:'top',
                            distance :0,
                            formatter: '{@[2]}',  // 取纬度为2的数据，既series 中 value[2]
                            fontSize:'1.5em',
                            fontWeight:1000,
                            color:'#fff'
                        },
                        itemStyle:{
                            normal:{
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgba(255,50,50,0.7)' // 0% 处的颜色
                                    },{
                                        offset: 1, color: 'rgba(255,50,50,0.05)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        }
                    },  {
                        type:'scatter',
                        symbol:'roundRect',
                        data:[
                            {
                                name:data.name,
                                value:data.coord
                            }
                        ],
                        coordinateSystem: "geo",
                        symbolSize:[10,60],
                        symbolOffset:[0, '-20%'],
                        itemStyle:{
                            normal:{
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgba(255,255,50,0.6)' // 0% 处的颜色
                                    },{
                                        offset: 1, color: 'rgba(255,255,50,0.05)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        }
                    },
                )
            }
            console.log('EchartsAreas 组件,series = ',series);
            this.splitSeries = series ;
            console.log('EchartsAreas 组件,this.splitSeries = ',this.splitSeries);
            this.setEchartsOptions();
        },
        setEchartsOptions(){
            // console.log('EchartsAreas 组件,setEchartsOptions  this.splitList = ',this.splitList)
            this.option = {
                tooltip:{},
                geo:[          
                    {
                        // 主图
                        map: 'china',
                        zlevel: 0,
                        zoom: 1.2, //当前视角的缩放比例
                        roam: false, //是否开启平游或缩放
                        center: undefined,
                        show: true,
                        // silent: true,
                        regions:this.splitList, // 有数据的省份设置颜色
                        label: {
                            normal: {
                                show: false,
                            },
                            emphasis: {
                                show: false,
                            },
                        },
                        itemStyle: {
                            normal: {
                                borderColor: "rgba(141, 199, 255,1)",
                                areaColor:'black'
                                // borderWidth: 1,
                                // areaColor: {
                                //     type: "pattern",
                                //     // image: domImg, //配置图片
                                //     // repeat: "repeat", //可选值repeat、no-repeat、repeat-x、repeat-y
                                // },
                            },
                            emphasis: {
                                areaColor: "#2d9eff", //悬浮区背景
                                shadowColor: "rgba(20, 113, 255,1)",
                                shadowOffsetX: -1,
                                shadowOffsetY: 3,
                                shadowBlur: 4,
                            },
                        },                      
                    },
                    // //第一层投影
                    {
                        map: 'china',
                        zlevel: -1,
                        zoom: 1.22, //当前视角的缩放比例
                        roam: false, //是否开启平游或缩放
                        center: undefined,
                        show: true,
                        
                        label: {
                            normal: {
                                show: false,
                            },
                            emphasis: {
                                show: false,
                            },
                        },
                        itemStyle: {
                            normal: {
                                // borderJoin: "round",
                                borderColor: "rgba(176,228,252,1)",
                                // borderWidth: 3,
                                areaColor: "rgba(133,188,232,1)",
                                shadowColor: "rgba(133,188,232,.7)",
                                shadowOffsetX: -3,
                                shadowOffsetY: 6,
                                shadowBlur: 5,
                            },
                            emphasis: {
                                show: false,
                            },
                        },
                        regions: [ // 对某块地区的特殊处理
                            {
                                name: '南海诸岛', 
                                value: 0,
                                itemStyle: {
                                    normal: {
                                        opacity: 0, //透明度
                                        label: {show: false}
                                    }
                                }
                            }
                        ],
                    },
                    // 第二层投影
                    {
                        map: 'china',
                        zlevel: -2,
                        zoom: 1.2, //当前视角的缩放比例
                        roam: false, //是否开启平游或缩放
                        center: undefined,
                        show: true,
                        label: {
                            normal: {
                                show: false,
                            },
                            emphasis: {
                                show: false,
                            },
                        },
                        itemStyle: {
                            normal: {
                                // borderJoin: "round",
                                areaColor: "rgba(30,49,105,1)",
                                shadowColor: "rgba(30,49,105,1)",
                                shadowOffsetX: -5,
                                shadowOffsetY: 10,
                                // shadowBlur: 20,
                            },
                            emphasis: {
                                show: false,
                            },
                        },
                        regions: [ // 对某块地区的特殊处理，
                            {
                                name: '南海诸岛', 
                                value: 0,
                                itemStyle: {
                                    normal: {
                                        opacity: 0, //透明度
                                        label: {show: false}
                                    }
                                }
                            }
                        ],
                    },
                ],
                series: this.splitSeries,
            }
            this.areaChart.setOption(this.option);
        }
    },
    mounted() {
        this.getHostListDatas();
        
        this.areaChart = echarts.init(this.$refs.areaChart,'dark');
            // 注册当前使用的地图名,参数1：自定义地图名，参数2：引入的地图名
        echarts.registerMap("china",mapDatas);
        
        // 当echarts地图发生点击事件时，给 home 组件发送省份名和中心位置信息
        this.areaChart.on('click',(params)=>{
            console.log('EchartsAreas 组件, 发生点击事件，并且点击后获取的信息是',params,this.areaChart.convertFromPixel('geo'));
            this.getProvinceName(params);
        })

        this.$bus.on('showEchartsAreas',this.showEchartsAreas);   

        window.addEventListener("resize",()=>{
            this.areaChart.resize();
        })
    },
}
</script>

<style scoped>
.container{
    position: absolute;
    top: 1%;
    left: 0.5%;
    right: 64%;
    bottom: 32%;
    /* border: 2px solid red; */
    /* width:800px; */
    /* height: 700px; */
    display: flex;
    justify-content: center;
    background-color: #0E0E25;
    border: 1px solid wheat;
    overflow: hidden;
    /* align-items: center; */
    border-radius: 5px;

}
.content{
    width: 650px;
    height: 500px;
    /* line-height: 100%; */
}

.containerBody{
    margin-top: 1%;
    width: 100%;
    height: 97%;
    border-radius: 5px;
    overflow: hidden;
    /* border: 1px solid wheat; */
}
.popup-close-button {
    position: absolute;
    top: 0;
    right: 14px;
    padding: 5px 10px 0 0;
    text-align: center;
    width: 18px;
    height: 14px;
    font: 20px/16px Tahoma, Verdana, sans-serif;
    text-decoration: none;
    font-weight: 700;
    background: transparent;
    z-index: 9999;
    color: aliceblue;
  }

  .popup-close-button:hover {
    cursor: pointer;
    color: red;
  }
</style>